<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="slider-container">
    <span style="width:100%">{{slidertxt}}</span>
    <div class="slider-labels">
      <span>{{sliderMinValTxt}}</span>
      <span>{{sliderMaxValTxt}}</span>
    </div>
    <input type="range"
           :min="min"
           :max="max"
           :step="step"
           v-model="sliderValue"
           @input="updateValue" />
    <div class="slider-labels">
      <span>{{ min }}</span>
      <span>{{ sliderValue }}</span>
      <span>{{ max }}</span>
    </div>
  </div>
</template>

<script>

  export default {
    name: "element-view-slider",
    components: {

    },
    props: {
      el: {
        type: Object,
        default: { Elements: [] }
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      visible: {
        required: false,
        type: Boolean,
        default: true
      },
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100
      },
      step: {
        type: Number,
        default: 1
      },
      value: {
        type: Number,
        default: 0
      },      
    },
    data() {
      return {
        sliderValue: 0, // default value
        slidertxt: '',
        sliderMinValTxt: '',
        sliderMaxValTxt: '',
      };
    },
    methods: {
      getValue(el,min) {
        var returnVal = min;
        if (el.UserInputs != null && typeof (el.UserInputs != 'undefined') && el.UserInputs.length > 0) {
          returnVal = el.UserInputs[0].Value;
        }
        return returnVal;
      },
      setvalue() {
        var userInput = {
          ElementType: 22,
          IsChanged: true
        };

        userInput.Value = this.sliderValue;

        if (this.el.UserInputs.length > 0) {
          this.el.UserInputs[0].IsChanged = true
          this.el.UserInputs[0].Value = userInput.Value;

        }
        else {
          userInput.ParentId = this.el.Id;
          this.el.UserInputs.push(userInput);
        }

        Vue.set(this.el, "UserInputs", this.el.UserInputs)
        this.$parent.onChange(this.el);
      },
      updateValue() {
        //console.log('val-' + this.currentValue)
        //this.$emit('input', this.sliderValue);
        this.setvalue();
      },
      deleteuserInputItem(el, userInput) {
        userInput.IsDeleted = true;
        Vue.set(el, "UserInputs", el.UserInputs);
        this.$forceUpdate();
        this.$emit("changed");
      },      
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {
        this.slidertxt = this.el.Text;
        console.log(this.el);
        if (this.el.Settings != null && this.el.Settings.Property != null) {
          if (this.el.Settings.Property.sliderMinVal != undefined)
            this.min = parseInt(this.el.Settings.Property.sliderMinVal);
          if (this.el.Settings.Property.sliderMaxVal != undefined)
            this.max = parseInt(this.el.Settings.Property.sliderMaxVal);
          if (this.el.Settings.Property.sliderSteps != undefined)
            this.step = parseInt(this.el.Settings.Property.sliderSteps);
          if (this.el.Settings.Property.sliderMinValTxt != undefined)
            this.sliderMinValTxt = this.el.Settings.Property.sliderMinValTxt;
          if (this.el.Settings.Property.sliderMaxValTxt != undefined)
            this.sliderMaxValTxt = this.el.Settings.Property.sliderMaxValTxt;

        }        
        this.sliderValue = this.getValue(this.el, this.min);
      }
    },
    computed: {
      elements: {
        get() {
          return this.el.Elements;
        }
      }
    },
    watch: {
      // Watching a single property
      el(newVal, oldVal) {
        this.init();
      }
    },
    mounted() {
      this.init();
    },
    created() {
      
    },
  };

</script>

<style scoped>
  .slider-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  input[type="range"] {
    width: 100%;
  }

  .slider-labels {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-viewing-elements/element-view-slider.vue